import { EuiListGroupItem, EuiIcon } from "@elastic/eui"
import React from "react";

export const ItemList = (props:any) =>{

    const {data, onClickItem, actions, onRemoveItem, active} = props;

    const onClick = ()=>{
        onClickItem(data)
    }

    const getRemoveAction = ():any =>{
        if(onRemoveItem){
            return {
                color: 'danger',
                onClick: ()=> onRemoveItem(data),
                iconType: 'crossInACircleFilled',
                iconSize: 's',
                'aria-label': 'Eliminar',
                alwaysShow: true
                }
        }else{return {}}
    }

    return <EuiListGroupItem 
    isDisabled={ active }
    label={data.label}
    extraAction={getRemoveAction()}
    iconType={'user'} 
    size='s'
    onClick={()=> !actions && onClick()}/>
}